// This file is auto-generated or manually updated to reflect the current app version.
export const APP_VERSION = "0.1.0";
